<template>
  <div class="pre-header-banner">
    <div
      ref="carouselContainer"
      class="
        pre-header-banner__container
        container
        liquid
        text-center
        splide
      "
      role="complementary"
      :aria-label="$string('general.pre_header_banner.carousel')"
      js-carousel="pre-header"
    >
      <div
        v-if="preHeaderBannerContent.length"
        class="splide__track"
      >
        <ul class="splide__list">
          <template
            v-for="(banner, index) of preHeaderBannerContent"
            :key="index"
          >
            <li
              v-if="banner.url"
              class="splide__slide"
            >
              <a
                :href="banner.url"
                class="text-body-s-link"
                v-html="banner.message"
              />
            </li>
            <li
              v-else
              class="splide__slide text-utility-capitalized-s"
              v-html="banner.message"
            />
          </template>
        </ul>
      </div>

      <multi-store-options
        class="pre-header-banner__multi-store-options"
        inline
        namespace="pre-header-banner"
      />

      <!-- Carousel Arrows -->
      <div
        v-if="showArrows"
        class="pre-header-banner__arrows splide__arrows"
      >
        <button
          class="splide__arrow splide__arrow--prev"
          type="button"
          :aria-label="$string('accessibility.carousel.previous')"
        >
          <icon-chevron-left />
        </button>

        <button
          class="splide__arrow splide__arrow--next"
          type="button"
          :aria-label="$string('accessibility.carousel.next')"
        >
          <icon-chevron-right />
        </button>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Component / Global: Site header
 * -----------------------------------------------------------------------------
 * Site header component, contains menu drawer and meganav.
 * - No style import as it's included in critical stylesheet.
 *
 */
import { nextTick } from 'vue'

import Carousel from '~/api/carousel'

import MultiStoreOptions from '~global/multi-store-options/multi-store-options'

import IconChevronLeft from '~icons/direction/chevron/left.svg'
import IconChevronRight from '~icons/direction/chevron/right.svg'

export default {
  name: 'PreHeaderBanner',

  components: {
    IconChevronLeft,
    IconChevronRight,
    MultiStoreOptions,
  },

  props: {
    preHeaderBannerContent: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectors: {
        container: '[js-carousel="pre-header"]',
      },
    }
  },

  computed: {

    /**
     * Calculate whether to show carousel arrows.
     * @returns {Boolean}
     */
    showArrows() {
      return this.preHeaderBannerContent?.length > 1
    },
  },

  mounted() {
    this.createCarousel()
  },

  methods: {

    /**
    * Main carousel contructor function
    */
    createCarousel() {
      nextTick().then(() => {
        const container = this.$refs.carouselContainer

        if (!container) {
          return
        }

        Carousel(
          this.selectors.container,
          {
            type: this.showArrows ? 'loop' : 'pause',
            rewind: true,
            autoplay: this.showArrows,
            drag: this.showArrows,
            pauseOnHover: true,
            interval: 5000,
            arrows: this.showArrows,
          },
        ).mount()
      })
    },
  },
}
</script>
